import React from "react";
import { Outlet } from "react-router-dom";
const ModuleRouter = () => {
  return <Outlet />;
};

export default ModuleRouter;
